import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export enum PageId {
  Start = 'start',
  InviteClient = 'inviteclient',
  PersonalInfo = 'personalinfo',
  RiskTolerance = 'risktolerance',
  Goals = 'goals',
  Accounts = 'accounts',
  ManageLinks = 'manageLinks',
  OtherAssets = 'otherassets',
  StockOptions = 'stockoptions',
  TaxFiling = 'taxfiling',
  Expenses = 'expenses',
  Income = 'income',
  Insurance = 'insurance',
  DocumentVault = 'documentvault',
  EstatePlanningPersonalInfo = 'estatePlanningPersonalInfo',
  EstatePlanningWorkflowReview = 'estatePlanningWorkflowReview',
}

export enum WorkflowIdEnum {
  Comprehensive,
  AssetBucketing,
  EstatePlanning,
}

interface FetchWorkflowParams {
  clientId: string;
  pageId: PageId;
  workflowId: WorkflowIdEnum;
}

export interface WorkflowData {
  WorkflowId: WorkflowIdEnum;
  Title: string;
  NumSteps: number;
  Route: {
    Name: string;
    Params: {
      pageId: PageId;
      workflowId: WorkflowIdEnum;
      clientId: number;
      pivotId: number;
      stepId: string;
      goalId: string;
    };
  };
  CurStep: number;
}

export const fetchWorkflowData = async ({
  clientId,
  pageId,
  workflowId,
}: FetchWorkflowParams): Promise<WorkflowData> => {
  return authFetch(
    urlWithParams('/Consumer/Workflow/GetPageRoute', {
      clientId,
      pageId,
      WorkflowId: workflowId,
    }),
  );
};

interface UseWorkflowDataQueryParams extends FetchWorkflowParams {}

export const useWorkflowDataQuery = ({
  clientId,
  pageId: rawPageId,
  workflowId,
}: UseWorkflowDataQueryParams) => {
  const pageId: PageId = useMemo(() => {
    if (rawPageId === 'manageLinks') {
      return PageId.Accounts;
    }

    return rawPageId;
  }, [rawPageId]);

  return useQuery(
    queryKeys.workflowData(clientId, pageId),

    () => fetchWorkflowData({ clientId, pageId, workflowId }),

    {
      enabled: pageId !== 'start',
    },
  );
};
